import { Route } from '@angular/router';
import { HeaderComponent } from '@ffx/ui';
import { authenticationGuard } from './guards/authentication/authentication.guard';
import { memberGuard } from './guards/member/member.guard';
import { ownerGuard } from './guards/owner/owner.guard';
import { projectSettingsDataResolver } from './resolvers/project-settings-data/project-settings-data.resolver';

export const appRoutes: Route[] = [
    {
        path: '',
        loadComponent: () => import('@ffx/feature-dashboard').then((m) => m.DashboardComponent),
        canActivate: [authenticationGuard]
    },
    {
        path: 'login',
        loadComponent: () => import('@ffx/feature-login').then((m) => m.LoginComponent)
    },
    {
        path: ':id',
        component: HeaderComponent,
        canActivateChild: [authenticationGuard],
        children: [
            {
                path: 'members',
                loadChildren: () => import('@ffx/feature-members').then((m) => m.membersRoutes),
                canActivate: [ownerGuard],
                resolve: {
                    populatedFeatureFlagStore: projectSettingsDataResolver
                }
            },
            {
                path: 'history',
                loadChildren: () => import('@ffx/feature-history').then((m) => m.historyRoutes),
                canActivate: [ownerGuard],
                resolve: {
                    populatedFeatureFlagStore: projectSettingsDataResolver
                }
            },
            {
                path: 'settings',
                loadChildren: () => import('@ffx/feature-project-settings').then((m) => m.projectSettingsRoutes),
                canActivate: [ownerGuard],
                resolve: {
                    populatedFeatureFlagStore: projectSettingsDataResolver
                }
            },
            {
                path: 'setup',
                loadChildren: () => import('@ffx/feature-setup').then((m) => m.setupRoutes),
                canActivate: [memberGuard],
                resolve: {
                    populatedFeatureFlagStore: projectSettingsDataResolver
                }
            },
            {
                path: 'flags',
                loadChildren: () => import('@ffx/flags').then((m) => m.flagsRoutes),
                canActivate: [memberGuard],
                resolve: {
                    populatedFeatureFlagStore: projectSettingsDataResolver
                }
            }
        ]
    },
    {
        path: '**',
        redirectTo: '/',
        pathMatch: 'full'
    }
];
